var React = require('react');

function TestimonialQuotemarkDesktop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.0195 0l1.2598 1.84766C22.1439 13.8854 17.1608 27.2949 10.3301 42.0762H0c1.67969-6.4388 3.35938-13.7175 5.03906-21.836C6.66276 12.1777 7.83854 5.43099 8.56641 0H24.0195zm30.9903 0l1.0078 1.84766c-1.2318 5.03906-3.2194 11.30994-5.9629 18.81254-2.7435 7.5026-5.683 14.6412-8.8184 21.416H30.9062C34.6016 27.8548 37.485 13.8294 39.5566 0h15.4532z","fill":"#6C727B"}));
}

TestimonialQuotemarkDesktop.defaultProps = {"fill":"none","viewBox":"0 0 57 43"};

module.exports = TestimonialQuotemarkDesktop;

TestimonialQuotemarkDesktop.default = TestimonialQuotemarkDesktop;
